import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

interface ArtifactNodeData {
  label: string;
  type: string;
  creator: string;
  preview?: string;
  version: number;
}

const ArtifactNode: React.FC<NodeProps<ArtifactNodeData>> = ({ data, isConnectable }) => {
  const getTypeIcon = () => {
    switch (data.type.toLowerCase()) {
      case 'text': return '📝';
      case 'code': return '💻';
      case 'image': return '🖼️';
      case 'idea': return '💡';
      case 'critique': return '🔍';
      case 'solution': return '✅';
      case 'document': return '📄';
      case 'diagram': return '📊';
      default: return '📄';
    }
  };

  return (
    <div className="artifact-node bg-white rounded-lg shadow-lg border border-gray-200 p-3 min-w-[180px]">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3"
      />
      
      <div className="flex items-start">
        <div className="mr-2 text-xl">{getTypeIcon()}</div>
        
        <div className="flex-grow">
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-medium text-gray-900 truncate">{data.label}</h3>
            <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded text-gray-700">v{data.version}</span>
          </div>
          
          <div className="text-xs text-gray-500">
            By {data.creator}
          </div>
        </div>
      </div>
      
      {data.preview && (
        <div className="mt-2 border border-gray-200 rounded overflow-hidden">
          {data.type.toLowerCase() === 'image' ? (
            <img src={data.preview} alt="Preview" className="w-full h-20 object-cover" />
          ) : (
            <div className="p-2 bg-gray-50 text-xs font-mono truncate">
              {data.preview}
            </div>
          )}
        </div>
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="w-3 h-3"
      />
    </div>
  );
};

export default memo(ArtifactNode);
